// @ts-nocheck
// 该文件由 kmi 自动生成
// DO NOT CHANGE IT MANUALLY!
import { getWeblog } from './weblogger';
import { createRadar, radar } from './radar';

export async function onPluginCreated() {
  createRadar();
  const weblogger = await getWeblog();
  radar.bindWeblogger(weblogger);
}
  

import React, { useState } from 'react';
import { ApplyPluginsType } from '@kmi/kmijs';
import { getPluginManager } from '../core/plugin';
import { ErrorBoundary } from '/media/disk1/fordata/jenkins/rbdNodeJs/workspace/node_modules/react-error-boundary';

function ErrorProvider(props: any) {
  const [globalErrorStage, setGlobalErrorStage] = useState('');

  const errorConfig = getPluginManager().applyPlugins({
    key: 'monitorErrorConfig',
    type: ApplyPluginsType.modify,
    initialValue: {}
  });

  let { fallbackComponent, onError, ...others} = errorConfig;

  const fallbackComp = fallbackComponent || function ({ error }){
    return <></>;
    // return (
    //   <div role="alert">
    //     <p style={ { color: 'red', fontSize: '20px' } }>Something went wrong [catch by monitor]:</p>
    //     <pre style={ { color: 'red' } }>message: {error.message}</pre>
    //     <pre>{globalErrorStage}</pre>
    //   </div >
    // );
  };

  const errorCallBack = onError || function (error: Error, info: { componentStack: string }) {
    radar.captureException({
      message: '[ErrorBoundary]' + error?.message,
      stack: error.stack
    });
  }

  return (
    <ErrorBoundary
      FallbackComponent={fallbackComp}
      onError={(error, info) => {
        const { componentStack } = info;
        setGlobalErrorStage(componentStack);
        errorCallBack(error, info);
      }}
      {...others}
    >
      {props.children}
    </ErrorBoundary>
  );
}

export function innerProvider(container: any) {
  return <ErrorProvider>{container}</ErrorProvider>
}